import React, { useState, useEffect, useCallback, useMemo } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import Menu from "./components/Menu";
import LoginPage from "./components/LoginPage";
import DataUploader from "./components/DataUploader";
import Dashboard from "./Dashboard";
import ImportCapital from "./components/ImportCapital";
import Account from "./components/Account";
import LandingPage from "./components/LandingPage";
import { Flowbite } from "flowbite-react";
import AutoSettings from "./components/AutoSettings";
import AutoHistory from "./components/AutoHistory";
// import { customTheme } from "./components/ui/theme";

const App = () => {
  const [user, setUser] = useState(null);
  const [currentPage, setCurrentPage] = useState("landing");
  const [isLoading, setIsLoading] = useState(true);
  const [yearlySummary, setYearlySummary] = useState({ totalPL: 0 });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setIsLoading(false);
      if (currentUser) {
        setCurrentPage('dashboard');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleNavigate = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleUploadSuccess = useCallback(() => {
    console.log("Upload was successful");
  }, []);

  const updateYearlySummary = useCallback((summary) => {
    setYearlySummary(summary);
  }, []);

  const renderContent = useMemo(() => {
    switch (currentPage) {
      case "landing":
        return <LandingPage onNavigate={handleNavigate} />;
      case "login":
        return <LoginPage />;
      case "dashboard":
        return <Dashboard updateYearlySummary={updateYearlySummary} />
      case "autosettings":
        return <AutoSettings />
      case "autohistory":
        return <AutoHistory />
      case "faq":
        return <h1 className="p-4">Coming soon</h1>;
      case "datauploader":
        return <DataUploader onUploadSuccess={handleUploadSuccess} />
      case "importcapital":
        return <ImportCapital />
      case "account":
        return <Account />
      default:
        return <LandingPage onNavigate={handleNavigate} />;
    }
  }, [currentPage, updateYearlySummary, handleUploadSuccess, handleNavigate, user]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Flowbite theme={{ mode: "dark" }}>
      <div className={`flex h-screen`}>
        {user && currentPage !== "landing" && (
          <Menu onNavigate={handleNavigate} currentPage={currentPage} yearlySummary={yearlySummary} />
        )}
        <div className="flex-grow overflow-auto max-md:pt-14 dark:bg-slate-900 bg-slate-100 dark:text-white">
          {renderContent}
        </div>
      </div>
    </Flowbite>
  );
};

export default React.memo(App);